import React from "react";

const Tabs = ({ tabs, activeTab, onChange, className = "" }) => {
    return (
        <div className={`tabs ${className}`} role="tablist">
            {tabs.map((tab) => {
                const isActive = tab.id === activeTab;
                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`tabs__tab ${isActive ? "tabs__tab--active" : ""}`}
                        onClick={() => onChange(tab.id)}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default Tabs;
